import { Bling } from 'react-gpt'
import consoleLogger from '../console-logger'
import isStolApp from '../is-stolapp'
import queryString from 'query-string'
import isServerSide from '../is-server-side'

/**
 * sets ad targeting for in meta defined targets. For more information what ad targeting is visit: https://support.google.com/admanager/answer/2884033?hl=de
 * @param metaAdsTargets
 * @returns {boolean}
 */
const setAdsTargets = (metaAdsTargets) => {
  const [consoleLog] = consoleLogger('AdsTargets')

  if (!metaAdsTargets) return false
  addSpecialTargets(metaAdsTargets)
  consoleLog(metaAdsTargets)
  if (metaAdsTargets) {
    Object.keys(metaAdsTargets).forEach((target) => {
      Bling.setTargeting(target, metaAdsTargets[target].toString())
    })
  }

  return true
}

const clearAdsTargets = () => {
  Bling.clearTargeting()
}

const addSpecialTargets = (targets = {}) => {
  if (!isServerSide()) {
    if (isStolApp()) {
      const appInfo = window.athesia_react ? window.athesia_react.app_os + ' ' + window.athesia_react.app_ver : ' '
      targets['STOL7_app'] = 'ja'
      targets['STOL7_app_version'] = appInfo
    }
    const urlQuery = queryString.parse(window.location.search)
    if (urlQuery.dlabAdsTest === 'on') localStorage.setItem('dlabAdsTest', 'on')
    if (urlQuery.dlabAdsTest === 'off') localStorage.removeItem('dlabAdsTest')
    if ((urlQuery.dlabAdsTest !== undefined && urlQuery.dlabAdsTest !== 'off') || localStorage.getItem('dlabAdsTest')) {
      targets['test'] = '1'
    }
  }
}
export default setAdsTargets
export { clearAdsTargets, addSpecialTargets }
